let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8eYa0"), load("ladkM"), load("e1Z8a")]).then(() => parcelRequire('dQOC0'));